import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import heroBg from '../../assets/2.jpg';

import taj from '../../assets/taj-vista.webp';
import dairy from '../../assets/dairy-food.webp';
import aanchal from '../../assets/aanchal.webp';
import hotel from '../../assets/hotel-india.webp';
import bartaHospital from '../../assets/barta-hospital.webp';
import madicare from '../../assets/madicare.webp';

const PrivateProject = () => {
  const privateImages = [
    { src: taj, name: "Taj Vista" },
    { src: dairy, name: "Dairy Food" },
    { src: aanchal, name: "Anchal" },
    { src: hotel, name: "Hotel India" },
    { src: bartaHospital, name: "Barta Hospital" },
    { src: madicare, name: "Madicare" },
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[400px] md:h-[300px] bg-cover bg-center flex flex-col justify-center px-6 overflow-hidden"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <motion.div
          initial={{ y: -200, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          <h1 className="text-white text-4xl md:text-5xl font-bold">Private Project</h1>
          <div className="text-white mt-2 text-lg">
            <Link to="/" className="underline hover:text-gray-200">Home</Link> / Private Project
          </div>
        </motion.div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <hr />
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-10 t-5">
          Our Private Projects
        </h2>

        {/* Images only */}
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 2, ease: "easeOut" }}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
        >
          {privateImages.map((img, idx) => (
            <div key={idx} className="flex flex-col items-center">
              <img
                src={img.src}
                alt={img.name}
                className="w-full h-64 object-contain md:h-40"
              />
              <p className="font-semibold text-gray-700 text-center mt-2 text-lg">{img.name}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default PrivateProject;
